fetch("/assets/config/config.json")
  .then(async response => {
    window.env = await response.json();
    await import("./main");
  })

export { };
